import { render, staticRenderFns } from "./StandardOrderItem.vue?vue&type=template&id=252f9e4c&scoped=true"
import script from "./StandardOrderItem.vue?vue&type=script&lang=js"
export * from "./StandardOrderItem.vue?vue&type=script&lang=js"
import style0 from "./StandardOrderItem.vue?vue&type=style&index=0&id=252f9e4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f9e4c",
  null
  
)

export default component.exports